import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface PDFViewersProps {
  fileName: string;
}
interface DocumentProps {
  numPages: number;
}

function scaleDocumentWidth(
  number: number,
  screenWidth: number,
  maxNumber: number | null,
) {
  const scaleFactor = screenWidth / 1920;
  if (maxNumber && number * scaleFactor >= maxNumber) return maxNumber;
  return number * scaleFactor;
}

const IconStyle = {
  width: '48px',
  height: '48px',
  borderRadius: '10px',
  padding: 0,
  '&:hover': {
    bgcolor: 'grey',
    borderRadius: '6px',
    cursor: 'pointer',
  },
};

const PDFViewers = ({ fileName }: PDFViewersProps) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [numOfPages, setNumOfPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages }: DocumentProps) => {
    setNumOfPages(numPages);
    setPageNumber(1);
  };

  const prevPage = () => {
    if (pageNumber > 1) setPageNumber(pageNumber - 1);
  };

  const nextPage = () => {
    if (pageNumber < numOfPages) setPageNumber(pageNumber + 1);
  };

  return (
    <Stack>
      <Stack
        direction='row'
        width='100vw'
        justifyContent='space-between'
        alignItems='center'
        sx={{
          backgroundColor: 'transparent',
          padding: '20px',
        }}
      >
        <Box sx={IconStyle} onClick={prevPage}>
          <ChevronLeft
            sx={{
              color: '#fff',
              width: '48px',
              height: '48px',
            }}
          />
        </Box>
        <Box width='auto'>
          <Document
            file={fileName}
            onLoadSuccess={onDocumentLoadSuccess}
            error='Something went wrong'
          >
            <Page
              pageNumber={pageNumber}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              devicePixelRatio={2}
              width={scaleDocumentWidth(550, windowWidth, null)}
            />
          </Document>
        </Box>
        <Box sx={IconStyle} onClick={nextPage}>
          <ChevronRight
            sx={{
              color: '#fff',
              width: '48px',
              height: '48px',
            }}
          />
        </Box>
      </Stack>
      <Box
        sx={{
          backgroundColor: '#000000dd',
          width: '150px',
          alignSelf: 'center',
          borderRadius: '4px',
        }}
      >
        <Typography
          sx={{
            color: '#fff',
            textAlign: 'center',
          }}
        >
          <FormattedMessage defaultMessage='Page' /> {pageNumber} / {numOfPages}
        </Typography>
      </Box>
    </Stack>
  );
};

export default PDFViewers;
